import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { PageTreeSearchMacroRendererProps } from '../src/PageTreeSearchMacroRenderer.tsx';

export const PageTreeSearchMacroHandler: LoadableType<PageTreeSearchMacroRendererProps> =
	LoadablePaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-PageTreeSearchMacro" */ '../src/PageTreeSearchMacroRenderer.tsx'
				)
			).PageTreeSearchMacroRenderer,
	});
